import{ ariaToggle } from "../utils/aria-toggle";
export default () =>{
  let openTrigger = document.querySelector("header li.search a");
  let closeTrigger = document.querySelector("button.close_search");
  let searchInput = document.querySelector('.search_input.desktop input[type="search"]');
  let target = document.querySelector(".search_input.desktop");
  let CloseSearchInput = document.querySelector(".search_input p.close-search-input-btn");
  let triggers = document.querySelectorAll(".desktop-nav .main-nav .menu a.trigger");
  let nav_screens = document.querySelectorAll(".desktop .nav-screen");
  /*let blur_overlay = document.querySelector("#blur-overlay");*/
  if (openTrigger){
    openTrigger.addEventListener("click", function (e){
      e.preventDefault();
      if (target.classList.contains("open")){
        target.classList.remove("open");
      } else{
        target.classList.add("open");
        /*blur_overlay.classList.remove("open");*/
        for(let j = 0; j < nav_screens.length; j++){
          nav_screens[j].classList.remove("open");
        }
        for(let i = 0; i < triggers.length; i++){
          triggers[i].classList.remove("open");
          triggers[i].ariaExpanded = false;
        }
      }
      searchInput.focus();
    });
  }
  if(CloseSearchInput){
    CloseSearchInput.addEventListener("click", function (e){
      e.preventDefault();
      target.classList.remove("open");
    });
  }
  if (closeTrigger){
    closeTrigger.addEventListener("click", function (e){
      e.preventDefault();
      target.classList.remove("open");
    });
  }
  let jump_links = document.querySelector(".search #search_jump_links");
  let jump_button = document.querySelector(".search #search_jump_expand");
  if (jump_links && jump_button){
    let jump_anchors = jump_links.querySelectorAll("a");
    jump_button.addEventListener("click", function (e){
      e.preventDefault();
      jump_links.classList.toggle("open");
      jump_button.classList.toggle("open");
      jump_button.ariaToggle("aria-expanded");
    });
    for (let i = 0; i < jump_anchors.length; i++){
      jump_anchors[i].addEventListener("click", function (){
        jump_links.classList.remove("open");
        jump_button.classList.remove("open");
        jump_button.ariaToggle("aria-expanded");
      });
    }
  }
};